// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__EUCzu","info":"UpdateTermsInfo_info__1OpAP"};